import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      fontSize: 14,
    },
    textCenterTop: {
      textAlign: 'center',
    },
    img: {
      width: '100%',
      height: 'auto',
    },
    trait: {
      backgroundColor: 'yellow',
      width: '75px',
      height: '5px',
      marginTop: '50px',
      marginBottom: '50px',
      margin: '0 auto',
    },
    bigMargin: {
      margin: '25vh 0',
      [theme.breakpoints.down('xs')]: {
        margin: '15vh 0',
      },
    },
    logo: {
      width: '50%',
      height: 'auto',
      display: 'block',
      margin: 'auto',
    },
    paragraphe: {
      fontSize: '14px',
      color: '#2B56A5',
      '@media only screen and (max-width: 600px)': {
        textAlign: 'left !important',
      },
      '@media only screen and (max-width: 361px)': {
        textAlign: 'left !important',
      },
    },
    fontWeightBold: {
      fontWeight: 'bold',
    },
    trait00: {
      backgroundColor: 'yellow',
      width: '75px',
      height: '5px',
      display: 'block',
      margin: 'auto',
      marginTop: '50px',
      marginBottom: '50px',
    },
  })
);

export default useStyles;
